// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"29d529b5","453":"97d18808","732":"8db95350","977":"a2dc7410"}[chunkId] + ".chunk.js";
};